import Vue from 'vue';

import VueMoment from 'vue-moment';

// 1. Load moment FROM moment-timezone (this gives us timezone support immediately)
import moment from 'moment-timezone';

// 2. Extend moment with moment-range
import { extendMoment } from 'moment-range';
const extendedMoment = extendMoment(moment);

// 3. Load languages
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/fr';

// 4. Set locale
extendedMoment.locale(getLang());

// 5. Install VueMoment with the CORRECT instance
Vue.use(VueMoment, { moment: extendedMoment });

// 6. Now all filters must also use extendedMoment, NOT Moment()
Vue.filter('moment', function (value, format, showTimeOnlyInSameDay) {
    if (!value || !format) return '';

    let momentValue = extendedMoment(value);
    if (showTimeOnlyInSameDay && momentValue.isSame(extendedMoment(), 'day')) {
        return extendedMoment(value).format('HH:mm');
    }
    return extendedMoment(value).format(format);
});

Vue.filter('momentTimeFromNow', function(value) {
    let today = extendedMoment();
    let momentValue = extendedMoment(value);

    if (today > momentValue) {
        return momentValue.fromNow();
    }
    if (today.isSame(value, 'date')) {
        return extendedMoment(value).format('HH:mm');
    }
    return momentValue.fromNow();
});

function getLang() {
    try {
        if (navigator.languages != null)
            return navigator.languages[0];
        return navigator.language;
    } catch (e) {
        console.warn('Error getting language', e);
        return 'de';
    }
}
